import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import FieldProductionTrendStore from "../store/FieldProductionTrendStore";
import { createContext } from "react";
import moment from "moment";
import { Skeleton } from "antd";

import { Observer } from "mobx-react-lite";
const fieldProductionTrendStoreCtx = createContext(FieldProductionTrendStore);
export const ProductionTrendChart = () => {
  const fieldProductionTrendStore = useContext(fieldProductionTrendStoreCtx);
  return (
    <Observer>
      {() => {
        const plotData = fieldProductionTrendStore.plotData || [];
        const getSeriesData = (field) =>
          plotData.map((point) => {
            const value = Number(point?.[field]);
            return Number.isFinite(value) ? value : null;
          });

        return fieldProductionTrendStore.isIniatilizing ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                zoomType: "xy",
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },
              title: {
                text: `${fieldProductionTrendStore.selectedField.fieldName} Field Production `,
                align: "center",
              },
              subtitle: {
                text: "",
              },
              xAxis: [
                {
                  categories: plotData.map((point) =>
                    point?.productionDate
                      ? moment(point.productionDate).format("MM-Y")
                      : ""
                  ),
                  crosshair: true,
                },
              ],
              yAxis: [
                {
                  // Tertiary yAxis
                  gridLineWidth: 0,
                  min: 0,
                  title: {
                    text: "Gas  (Mscf/d)",
                  },
                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                },
                {
                  // Secondary yAxis
                  gridLineWidth: 0,
                  title: {
                    text: " Oil (stb/d)",
                  },
                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                },
                {
                  // Tertiary yAxis
                  gridLineWidth: 0,
                  title: {
                    text: "Water (stb/d)",
                  },

                  opposite: true,
                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                },
                {
                  // Tertiary yAxis
                  gridLineWidth: 0,
                  title: {
                    text: "GOR",
                  },

                  lineWidth: 1,
                  minorGridLineWidth: 1,
                  minorTickInterval: "auto",
                  minorTickWidth: 1,
                  tickPosition: "outside",
                  tickWidth: 2,
                  opposite: true,
                },
              ],
              tooltip: {
                shared: true,
              },
              legend: {
                layout: "horizontal",
                align: "center",

                verticalAlign: "bottom",

                backgroundColor: "#FFFFFF",
              },
              series: [
                {
                  name: "Oil",

                  type: "spline",

                  yAxis: 1,
                  data: getSeriesData("oil"),
                  tooltip: {
                    valueSuffix: " stb/d",
                  },
                  marker: {
                    enabled: false,
                  },
                  color: "red",

                  fillOpacity: 0.1,
                },
                {
                  name: "Water",
                  type: "spline",
                  yAxis: 2,
                  data: getSeriesData("water"),
                  marker: {
                    enabled: false,
                  },
                  color: "blue",
                  tooltip: {
                    valueSuffix: " stb/d",
                  },
                },

                {
                  name: "Gas ",
                  color: "green",
                  type: "spline",
                  data: getSeriesData("gas"),
                  tooltip: {
                    valueSuffix: " Mscf/d",
                  },
                  marker: {
                    enabled: false,
                  },
                },
                {
                  name: "GOR ",
                  color: "black",
                  visible: false,
                  yAxis: 3,

                  data: getSeriesData("gor"),
                  tooltip: {
                    valueSuffix: " stb/Mscf",
                  },
                  marker: {
                    enabled: false,
                  },
                },
              ],
            }}
          />
        );
      }}
    </Observer>
  );
};

